module.exports = __webpack_public_path__ + "static/media/manatee_banner.3b0f3210.jpg";